export default __webpack_public_path__ + "static/media/pic87.1b72a7ea.jpg";